export default __webpack_public_path__ + "static/media/paypal.88f58c01.svg";